import { render, staticRenderFns } from "./UpsalesWindow.vue?vue&type=template&id=0ba0fe36&scoped=true&"
import script from "./UpsalesWindow.vue?vue&type=script&lang=js&"
export * from "./UpsalesWindow.vue?vue&type=script&lang=js&"
import style0 from "./UpsalesWindow.vue?vue&type=style&index=0&id=0ba0fe36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba0fe36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
